import React from 'react'
import { Container } from './styles'

interface Props {

}

const Card: React.FC<Props> = ({ children }) => {
  return (
    <Container>
      {children}
    </Container>
  )
}

export default Card
